import { Avatar, Badge } from "@design";
import { useTranslation } from "react-i18next";
import { AssistantAvatar } from "./AssistantAvatar";

type MessageAuthorProps = Readonly<
  | {
      kind: "assistant";
      /** Defaults to "AnthmAI"; pass the agent's name when one answered. */
      name?: string;
      /** Formatted time, or a status line such as "responding to Priya…". */
      meta?: string;
    }
  | { kind: "participant"; name: string; initials: string; online?: boolean; meta?: string }
>;

/** The avatar + name row that heads an assistant or participant message. */
export function MessageAuthor(props: MessageAuthorProps) {
  const { t } = useTranslation("chat", { keyPrefix: "message" });
  return (
    <div className="flex items-center gap-3">
      {props.kind === "assistant" ? (
        <AssistantAvatar />
      ) : (
        <Avatar initials={props.initials} size="sm" status={props.online} />
      )}
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-content-primary">
          {props.kind === "assistant" ? (props.name ?? t("assistantName")) : props.name}
        </span>
        {props.kind === "assistant" && (
          <Badge variant="brand" size="compact">
            {t("aiBadge")}
          </Badge>
        )}
        {props.meta && <span className="text-xs text-content-tertiary">{props.meta}</span>}
      </div>
    </div>
  );
}
